// ## ClientlessAuthZFsm
//
// State machine for AuthZ status of Clientless (Flash/HTML5) Auth.

'use strict';

var machina = require('./vendor/machina');
var _logger = require('./logger');


var ClientlessAuthZFsm = machina.Fsm.extend({

	initialState : 'offline',

	states : {

		'offline' : {
			'ready' : 'ready'
		},

		'ready' : {

		}

	},

	checkAuthZ : function (/*resourceId, feature*/) {
		_logger.warn('Clientless has no authZ!');
	},

	handleInitReady : function () {
		this.handle('ready');
	},

	handleAuthZPass : function (obj) {
		this.handle('authZPass', obj);
	},

	handleAuthZFail : function (obj) {
		this.handle('authZFail', obj);
	},

	init : function (AuthManager) {
		if (!AuthManager) {
			throw new Error('AuthManager required for init!');
		}

		this.authManager = AuthManager;
	}

});


module.exports = ClientlessAuthZFsm;
